<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-col lg="12">
            <b-form-fieldset label="Periode" :label-cols="2" :horizontal="true">
              <div class="form-inline">
                <flat-pickr class="form-control col-sm-3 col-6" name="start_date" v-model="data.start_date" placeholder="Masukkan Tanggal Awal" :config="config"></flat-pickr>
                <span v-if="day === false" class="col-sm-1 text-center">s.d</span>
                <flat-pickr v-if="day === false" class="form-control col-sm-3 col-6" name="end_date" v-model="data.end_date" placeholder="Masukkan Tanggal Akhir" :config="config"></flat-pickr>
              </div>
            </b-form-fieldset>
          </b-col>
          <div slot="footer">
            <b-button v-bind:disabled="isLoading" @click="doExport" type="submit" :block="true" size="lg" variant="success">
              <span v-if="isLoading"><i class="fa fa-spin fa-spinner"></i> Loading</span>
              <span v-else><i class="fa fa-save"></i> Export Excel</span>
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from '@/helpers/api'
import qs from 'qs'

export default {
  name: 'Laporan',
  data: () => {
    return {
      config: {
        dateFormat: 'd-m-Y',
        allowInput: true
      },
      data: {
        start_date: '',
        end_date: ''
      },
      link: '',
      day: false,
      isLoading: false
    }
  },
  methods: {
    async doExport () {
      location.href = api.defaults.baseURL + '/laporan/' + this.link + '?' + qs.stringify(this.data)
    },
    checkRoute () {
      this.day = false

      if (this.$route.name === 'Laporan Harian') {
        this.day = true
        this.link = 'harian'
      }
      if (this.$route.name === 'Laporan Bulanan') {
        this.day = false
        this.link = 'bulanan'
      }
    }
  },
  mounted () {
    this.checkRoute()
  },
  watch: {
    '$route': function (a, b, c) {
      this.checkRoute()
    }
  }
}
</script>
